export default {
  'messages.title': 'Messages',
  'messages.no_messages': 'No messages',
  'messages.no_conversations': 'You don\'t have any conversations yet',
  'messages.start_conversation': 'Start a conversation',
  'messages.loading_conversation': 'Loading conversation...',
  'messages.send': 'Send',
  'messages.type_message': 'Type your message...',
  'messages.book_appointment': 'Book appointment',
  'messages.back_to_conversations': 'Back to conversations',
  'messages.starting_conversation': 'Starting conversation',
  'messages.please_wait': 'Please wait...',
  'messages.conversation_created': 'Conversation created',
  'messages.send_first_message': 'Send your first message!',
  'messages.error': 'Error',
  'messages.error_starting_conversation': 'Error starting conversation',
  'messages.error_sending_message': 'Error sending message',
  'messages.load_more': 'Load more',
  'messages.no_more_messages': 'No more messages',
  'messages.conversation_with': 'Conversation with',
  'messages.online': 'Online',
  'messages.offline': 'Offline',
  'messages.booking_confirmed': 'Booking confirmed',
  'messages.booking_failed': 'Booking failed',
  'messages.booking_info': 'Booking information',
  'messages.date': 'Date',
  'messages.time': 'Time',
  'messages.duration': 'Duration',
  'messages.price': 'Price',
  'messages.payment_method': 'Payment method',
  'messages.payment_status': 'Payment status',
  'messages.booking_status': 'Booking status',
  'messages.booking_details': 'Booking details',
  'messages.confirm_booking': 'Confirm booking',
  'messages.cancel_booking': 'Cancel booking',
  'messages.booking_success': 'Booking successful',
  'messages.booking_pending': 'Booking pending',
  'messages.booking_cancelled': 'Booking cancelled',
  'messages.payment_pending': 'Payment pending',
  'messages.payment_completed': 'Payment completed',
  'messages.payment_failed': 'Payment failed',
  'messages.archive': 'Archive',
  'Messages': 'Messages',
};
